import { snackbarsReducer } from './snackbars/snackbarsSlice';
import { formControlReducer } from 'store/formControl/formControlSlice';
import { employeeReducer } from './employees/empoloyeeSlice';
import { peopleAuthorizedListReducer } from './peopleAuthorizedList/peopleAuthorizedListSlice';
import { tableControlReducer } from './tableControlSlice/tableControlSlice';
import { companyAuthorizationListReducer } from './companyAuthorizedList/companyAuthorizationListSlice';
import { organizationListReducer } from './organizationList/organizationListSlice';
import { locationListReducer } from './locationList/locationListSlice';
import { cameraInfoReducer } from './cameraInfo/cameraInfoSlice';
import { divisionListReducer } from './divisionList/divisionListSlice';
import { monitoringElementReducer } from './MonitoringElement/monitoringElementSlice';
import { controlCentarReducer } from './controlCentar/controlCentarSlice';
import { monitoringObjectReducer } from './monitoringObject/monitoringObjectSlice';
import { authReducer } from './auth/authSlice';
import { globalLocationReducer } from 'components/globalLocationSelector/store/globalLocationSlice.js';
import { accessPointRecordsReducer } from '../components/accessPointRecords/store/accessPointRecordsSlice';
import { userLocationsReducer } from 'features/userLocations/store/userLocationsSlice';
import { featureFlagReducer } from 'store/featureFlag/featureFlagSlice';
import { audioConfigurationReducer } from 'features/audioConfiguration/store/AudioConfigurationSlice';
import { aiqEventTriggersConfigurationReducer } from 'features/AiqEventTriggersConfiguration/store/aiqEventTriggersConfigurationSlice';
import { relaysReducer } from './relays/relaysListSlice';
import { sharedReducer } from 'store/shared/sharedSlice';
import { clientPersonnelReducer } from 'features/clientPersonnel/store/clientPersonnelSlice';

export const staticReducers = {
    auth: authReducer,
    snackbars: snackbarsReducer,
    forms: formControlReducer,
    employee: employeeReducer,
    peopleAuthorizedList: peopleAuthorizedListReducer,
    tables: tableControlReducer,
    companyAuthorizationList: companyAuthorizationListReducer,
    cameraInfo: cameraInfoReducer,
    organizationList: organizationListReducer,
    locationList: locationListReducer,
    divisionList: divisionListReducer,
    monitoringElementList: monitoringElementReducer,
    controlCentarList: controlCentarReducer,
    monitoringObjectList: monitoringObjectReducer,
    globalLocationList: globalLocationReducer,
    accessPointRecordsList: accessPointRecordsReducer,
    userLocationsList: userLocationsReducer,
    featureFlag: featureFlagReducer,
    audioConfiguration: audioConfigurationReducer,
    aiqEventTriggersConfiguration: aiqEventTriggersConfigurationReducer,
    relays: relaysReducer,
    shared: sharedReducer,
    clientPersonnel: clientPersonnelReducer,
};
